<template>
  <div v-if="unreadMessageCount" class="pill__num big-pulse-animation">
    {{ unreadMessageCount }}
  </div>
</template>

<script>

import { mapGetters } from 'vuex';

export default {
  name: 'UnreadMessagesComponent',
  components: {},

  data() {
    return {};
  },
  computed: {
    ...mapGetters('user', {
      unreadMessageCount: 'getUserUnreadMessagesCount',
    }),
  },
  methods: {},
  watch: {},
  mounted() {
  }
};
</script>